module.exports = __webpack_public_path__ + "static/media/bKash_Logo_Icon.c9983731.svg";